import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit () {
    Teamshares.Rails.fire(this.element, "submit");
  }
}
